import { render, staticRenderFns } from "./ToBeReviewed.vue?vue&type=template&id=be3e9ea8&scoped=true"
import script from "./ToBeReviewed.vue?vue&type=script&lang=js"
export * from "./ToBeReviewed.vue?vue&type=script&lang=js"
import style0 from "./ToBeReviewed.vue?vue&type=style&index=0&id=be3e9ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3e9ea8",
  null
  
)

export default component.exports